'use client';

import React from 'react';
import { useTranslations } from 'next-intl';
import { useGTM } from '@/features/Analytics';
import type { PageType } from '@/features/Analytics';
import { Link } from '@/navigation';
import { classNames } from '@/shared/lib/classnames/classnames';
import { UnderlineEffect } from '@/shared/ui/underline-effect';
interface Props {
  size?: 'base' | 'lg';
  name: string;
  skill?: string;
  workExperience?: number;
  nameTag?: React.ElementType;
  skillLink?: string;
  doctorLink?: string;
  isTop?: boolean;
  medcenterName?: string;
  pageType: PageType;
}
export const DoctorTitle: React.FC<Props> = props => {
  const {
    skillLink,
    doctorLink,
    name,
    skill,
    workExperience,
    nameTag: NameTag = 'h1',
    isTop,
    medcenterName,
    pageType
  } = props;
  const t = useTranslations('doctor.profile');
  const {
    trackEvent
  } = useGTM(pageType);
  return <div className={classNames('', {
    'flex flex-col': Boolean(skill)
  })} data-sentry-component="DoctorTitle" data-sentry-source-file="DoctorTitle.tsx">
      {skill && (skillLink ? <Link href={{
      pathname: skillLink
    }}>
            <UnderlineEffect className="text-sm">{skill}</UnderlineEffect>
          </Link> : <p className="text-sm">{skill}</p>)}

      {doctorLink ? <Link href={{
      pathname: doctorLink
    }} onClick={() => {
      trackEvent('click_doctor_widget', {
        label: 'doctor_name',
        doctorName: name,
        skill: skill || '',
        in_ads: isTop || '',
        medcenterName: medcenterName || ''
      });
    }} scroll={true}>
          <span className="font-bold">
            <NameTag className="inline text-lg">
              {name}
              {workExperience && <span className="mx-2 text-lg">•</span>}
            </NameTag>
            <span className="text-lg">{workExperience ? t('experience', {
            count: workExperience
          }) : ''}</span>
          </span>
        </Link> : <div className="font-bold">
          <NameTag className="inline">
            {name}
            {workExperience && <span className="mx-2 hidden md:inline">•</span>}
          </NameTag>
          {workExperience && <span className="opacity-45 md:opacity-100">
              {t('doctor.profile.experience', {
          count: workExperience
        })}
            </span>}
        </div>}
    </div>;
};